import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { Order } from '../types/order';
import { GradientText } from '../../utils/theme';

const OrderDetail = () => {
  const location = useLocation();
  const orders = location.state?.orders as Order[];

  const groupedOrders = orders.reduce((acc, order) => {
    if (!acc[order.受注番号]) {
      acc[order.受注番号] = [];
    }
    acc[order.受注番号].push(order);
    return acc;
  }, {} as Record<number, Order[]>);

  return (
    <Box sx={{ p: 3 }}>
      <GradientText variant="h5" gutterBottom>
        注文詳細
      </GradientText>
      {Object.entries(groupedOrders)
        .sort(([orderNumberA], [orderNumberB]) => Number(orderNumberB) - Number(orderNumberA)) // 大きい受注番号順でソート
        .map(([orderNumber, orders]) => (
          <Paper key={orderNumber} sx={{ mb: 2, p: 2 }}>
            <Typography variant="h6" gutterBottom>
              受注番号: {orderNumber}
            </Typography>
            <Typography variant="body2" gutterBottom>
              納品希望日: {orders[0].納品希望日.replace("T", " ").replace(/-/g, "/")}
            </Typography>
            <Typography variant="body2" gutterBottom>
              発注日: {orders[0].注文日.replace("T", " ").replace(/-/g, "/").split(".")[0]}
            </Typography>
            <Typography variant="body2" gutterBottom>
              配送先: {orders[0].配送先名}
            </Typography>
            <List>
              {orders.map((order) => (
                <ListItem key={order.id}>
                  <ListItemText
                    primary={`商品名: ${order.商品名}`}
                    secondary={`数量: ${order.数量} ${order.単位}`}
                  />
                </ListItem>
              ))}
            </List>
            <Typography variant="body1" gutterBottom>
              コメント：<br/>{orders[0]['コメント（備考）']}
            </Typography>
          </Paper>
        ))}
    </Box>
  );
};

export default OrderDetail;
